(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dtn-qty-breaks"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dtn-qty-breaks')) {
    class DtnQtyBreaks extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;

        const json = this.querySelector('[data-dtn-qb-variants]');
        try {
          this.variants = JSON.parse(json ? json.textContent : '{}');
        } catch (e) {
          this.variants = {};
        }

        this.moneyFormat = this.dataset.moneyFormat || '$' + '{' + '{amount}' + '}';
        this.hideNative = this.dataset.hideNative === 'true';
        this.stockText = this.dataset.stockText || '';
        this.unitSuffix = this.dataset.unitSuffix || '';
        this.variantId = String(this.dataset.variantId || '');
        this.scope = this.closest('.shopify-section') || document;
        this.options = Array.from(this.querySelectorAll('[data-tier]'));

        this.options.forEach((opt) => {
          const input = opt.querySelector('input');
          input.addEventListener('change', () => this.select(opt));
        });

        this._onVariant = (e) => {
          const d = e.detail || {};
          const r = d.resource || d.variant || null;
          if (r && r.id && this.variants[String(r.id)]) {
            this.setVariant(String(r.id));
          } else {
            setTimeout(() => this.syncFromForm(), 60);
          }
          setTimeout(() => this.applyQty(), 80);
          setTimeout(() => this.applyQty(), 400);
        };

        this._onSubmit = (e) => {
          const form = e.target;
          if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
          if (!this.scope.contains(form)) return;
          this.syncFromForm();
          if (this.hideNative) this.applyQty(form);
        };

        this._onClick = (e) => {
          const btn = e.target.closest && e.target.closest('button[type="submit"], button[name="add"]');
          if (!btn || !this.scope.contains(btn)) return;
          if (this.hideNative) this.applyQty();
        };

        this._onScopeChange = (e) => {
          if (this.contains(e.target)) return;
          if (e.target && e.target.name === 'quantity') return;
          setTimeout(() => {
            this.syncFromForm();
            this.applyQty();
          }, 120);
        };

        document.addEventListener('variant:update', this._onVariant);
        document.addEventListener('submit', this._onSubmit, true);
        document.addEventListener('click', this._onClick, true);
        this.scope.addEventListener('change', this._onScopeChange);

        this.render(false);
        const initial =
          this.options.find((o) => o.querySelector('input').checked && !o.classList.contains('is-disabled')) ||
          this.options.find((o) => !o.classList.contains('is-disabled'));
        if (initial) this.select(initial);
      }

      disconnectedCallback() {
        document.removeEventListener('variant:update', this._onVariant);
        document.removeEventListener('submit', this._onSubmit, true);
        document.removeEventListener('click', this._onClick, true);
        if (this.scope) this.scope.removeEventListener('change', this._onScopeChange);
        this._ready = false;
      }

      select(opt) {
        if (!opt || opt.classList.contains('is-disabled')) return;
        this.options.forEach((o) => {
          const on = o === opt;
          o.classList.toggle('is-selected', on);
          o.querySelector('input').checked = on;
        });
        this.qty = parseInt(opt.dataset.qty, 10) || 1;
        this.applyQty();
      }

      forms() {
        return Array.from(this.scope.querySelectorAll('form[data-type="add-to-cart-form"]'));
      }

      applyQty(onlyForm) {
        if (!this.qty) return;
        const list = onlyForm ? [onlyForm] : this.forms();
        list.forEach((form) => {
          let inputs = Array.from(form.querySelectorAll('input[name="quantity"]'));
          if (form.id) {
            inputs = inputs.concat(
              Array.from(document.querySelectorAll('input[name="quantity"][form="' + form.id + '"]'))
            );
          }
          if (!inputs.length) {
            let hidden = form.querySelector('input[data-dtn-qb-hidden]');
            if (!hidden) {
              hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'quantity';
              hidden.setAttribute('data-dtn-qb-hidden', '');
              form.appendChild(hidden);
            }
            hidden.value = this.qty;
            return;
          }
          inputs.forEach((input) => {
            if (String(input.value) === String(this.qty)) return;
            input.value = this.qty;
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        });
      }

      syncFromForm() {
        const idInput = this.scope.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
        if (!idInput) return;
        const id = String(idInput.value);
        if (id && id !== this.variantId && this.variants[id]) this.setVariant(id);
      }

      setVariant(id) {
        if (id === this.variantId) return;
        this.variantId = id;
        this.render(true);
      }

      render(animate) {
        const v = this.variants[this.variantId];
        if (!v) return;
        const baseUnit = v.compare > v.price ? v.compare : v.price;
        let selectedStillValid = true;

        this.options.forEach((opt) => {
          const qty = parseInt(opt.dataset.qty, 10) || 1;
          const pct = parseFloat(opt.dataset.pct) || 0;
          const full = v.price * qty;
          const total = Math.round((full * (100 - pct)) / 100);
          const saved = full - total;
          const strike = baseUnit * qty;
          const noStock = !v.available || (v.inv !== null && v.inv < qty);

          opt.classList.toggle('is-disabled', noStock);
          opt.querySelector('input').disabled = noStock;
          if (noStock && opt.classList.contains('is-selected')) selectedStillValid = false;

          const tpl = opt.dataset.subTpl || '';
          const subText = noStock
            ? this.stockText
            : tpl.split('[ahorro]').join(this.formatMoney(saved)).split('[porcentaje]').join(pct + '%');

          this.swap(opt.querySelector('[data-total]'), this.formatMoney(total), animate);
          this.swap(opt.querySelector('[data-sub]'), subText, animate);

          const compareEl = opt.querySelector('[data-compare]');
          if (compareEl) {
            compareEl.hidden = !(strike > total);
            this.swap(compareEl, this.formatMoney(strike), animate);
          }

          if (v.img) {
            opt.querySelectorAll('[data-thumb]').forEach((img) => {
              if (img.getAttribute('src') === v.img) return;
              if (!animate) {
                img.src = v.img;
                return;
              }
              img.classList.add('is-swapping');
              setTimeout(() => {
                img.src = v.img;
                img.onload = () => img.classList.remove('is-swapping');
                setTimeout(() => img.classList.remove('is-swapping'), 500);
              }, 200);
            });
          }

          const unitEl = opt.querySelector('[data-unit]');
          if (unitEl) {
            unitEl.hidden = qty <= 1;
            const unitText = this.formatMoney(Math.round(total / qty)) + (this.unitSuffix ? ' ' + this.unitSuffix : '');
            this.swap(unitEl, unitText, animate);
          }
        });

        if (!selectedStillValid) {
          const fallback = this.options.find((o) => !o.classList.contains('is-disabled'));
          if (fallback) this.select(fallback);
        }
      }

      swap(el, text, animate) {
        if (!el || el.textContent.trim() === String(text).trim()) return;
        if (!animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          el.textContent = text;
          return;
        }
        el.classList.add('is-swapping');
        clearTimeout(el._dtnT);
        el._dtnT = setTimeout(() => {
          el.textContent = text;
          requestAnimationFrame(() => el.classList.remove('is-swapping'));
        }, 200);
      }

      formatMoney(cents) {
        const format = this.moneyFormat;
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const key = match ? match[1] : 'amount';
        const delim = (n, precision, thousands, decimal) => {
          thousands = thousands === undefined ? ',' : thousands;
          decimal = decimal === undefined ? '.' : decimal;
          const parts = (n / 100).toFixed(precision).split('.');
          const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return whole + (parts[1] ? decimal + parts[1] : '');
        };
        let value;
        switch (key) {
          case 'amount_no_decimals':
            value = delim(cents, 0);
            break;
          case 'amount_with_comma_separator':
            value = delim(cents, 2, '.', ',');
            break;
          case 'amount_no_decimals_with_comma_separator':
            value = delim(cents, 0, '.', ',');
            break;
          case 'amount_with_apostrophe_separator':
            value = delim(cents, 2, "'", '.');
            break;
          case 'amount_no_decimals_with_space_separator':
            value = delim(cents, 0, ' ');
            break;
          case 'amount_with_space_separator':
            value = delim(cents, 2, ' ', ',');
            break;
          case 'amount_with_period_and_space_separator':
            value = delim(cents, 2, ' ', '.');
            break;
          default:
            value = delim(cents, 2);
        }
        return format.replace(/\{\{\s*\w+\s*\}\}/, value);
      }
    }

    customElements.define('dtn-qty-breaks', DtnQtyBreaks);
  }
  } catch(e) { console.error(e); }
})();

})();
